import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { CallbackComponent } from './components/callback/callback.component';
import { RedirectCallbackComponent } from './components/callback/redirect-callback.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ResetPasswordSuccessComponent } from './components/reset-password/reset-password-success/reset-password-success.component';
import { ResetPwdErrorStateComponent } from './components/reset-password/error-state/reset-pwd-error-state.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { TwoFactorLoginComponent } from './components/two-factor-login/two-factor-login.component';
import { OauthComponent } from './containers/oauth.component';
import { ChallengeExpiryComponent } from './components/challenge-expiry/challenge-expiry.component';
import { OpenidCallbackComponent } from './components/openid-callback/openid-callback.component';
import { LinkedinSigninComponent } from './components/linkedin-siginin/linkedin-signin.component';
import { FacebookSigininComponent } from './components/facebook-signin/facebook-siginin.component';
import { GoogleSigninComponent } from './components/google-signin/google-signin.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ErrorContainerComponent } from './components/error-container/error-container.component';
import { OtpInputComponent } from './components/two-factor-login/otp-input/otp-input.component';
import { EqualToDirective } from './directives/equal-to.directive';

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        CoreModule,
        RouterModule,
        ReactiveFormsModule,
        OauthComponent,
        LoginComponent,
        ResetPasswordSuccessComponent,
        ResetPwdErrorStateComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        TwoFactorLoginComponent,
        OtpInputComponent,
        CallbackComponent,
        RedirectCallbackComponent,
        LogoutComponent,
        ChallengeExpiryComponent,
        OpenidCallbackComponent,
        GoogleSigninComponent,
        FacebookSigininComponent,
        LinkedinSigninComponent,
        ChangePasswordComponent,
        ErrorContainerComponent,
        EqualToDirective
    ],
    exports: [],
    providers: [],
})
export class OauthModule {
}
